import {Api, Method} from "../../api/api";

class ResetPassword {
  private api = new Api();

  private readonly formElement: HTMLFormElement;
  private answerElement: HTMLElement;
  private successElement: HTMLElement;
  private errorElement: HTMLElement;

  private readonly actionUrl: string;

  constructor() {
    this.formElement = document.querySelector(`.js-recovery-form`)!;

    this.answerElement = this.formElement.querySelector(`.js-answer`)!;
    this.successElement = this.formElement.querySelector(`.js-answer-success`)!;
    this.errorElement = this.formElement.querySelector(`.js-answer-error`)!;

    this.actionUrl = this.formElement.action;

    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  init() {
    this.formElement.addEventListener(`submit`, this.onFormSubmit);
  }

  private getFormData() {
    return new FormData(this.formElement);
  }

  private resetAnswer() {
    setTimeout(() => {
      this.answerElement.classList.remove(`show`);
      this.successElement.classList.remove(`show`);
      this.errorElement.classList.remove(`show`);
    }, 3000);
  }

  private showAnswer(status) {
    this.answerElement.classList.add(`show`);

    if (status === 200) {
      this.successElement.classList.add(`show`);
    } else if (status === 400) {
      this.errorElement.classList.add(`show`);
    } else {
      this.errorElement.classList.add(`show`);
    }

    this.resetAnswer();
  }

  private async post(): Promise<{status: number, answer: string}> {
    return await this.api.customQuery(this.actionUrl, {method: Method.POST, query: this.getFormData()});
  }

  async onFormSubmit(evt) {
    evt.preventDefault();

    const {status, answer} = await this.post();

    this.showAnswer(status);
  }
}

export {ResetPassword};
